import React from "react";
var __jsx = React.createElement;
import Img from '../../atoms/Img';
import Column from './Column';
function getOptimalThumbnail(imageObj) {
  var targetWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1100;
  if (!(imageObj !== null && imageObj !== void 0 && imageObj.thumbnails) || imageObj.thumbnails.length === 0) {
    return imageObj === null || imageObj === void 0 ? void 0 : imageObj.url;
  }
  var optimal = imageObj.thumbnails.reduce(function (best, current) {
    var bestDiff = Math.abs(best.width - targetWidth);
    var currentDiff = Math.abs(current.width - targetWidth);
    if (currentDiff < bestDiff) {
      return current;
    }

    // If differences are equal, prefer the larger one (better quality)
    if (currentDiff === bestDiff && current.width > best.width) {
      return current;
    }
    return best;
  });
  return optimal.url;
}
function LayoutTwoColImgText(_ref) {
  var yextInfo = _ref.yextInfo,
    isLoading = _ref.isLoading;
  console.log('yextInfo', yextInfo);
  return __jsx(React.Fragment, null, __jsx("div", {
    className: "l-col-full sm:l-col-4 md:l-col-3 lg:l-col-3 u-flex u-items-center u-relative"
  }, __jsx(Img, {
    classes: {
      img: 'u-w-full'
    },
    src: getOptimalThumbnail(yextInfo === null || yextInfo === void 0 ? void 0 : yextInfo.c_websiteBannerExpandedImage),
    height: 400,
    width: 600
  })), __jsx(Column, {
    isLoading: isLoading,
    className: "l-col-full sm:l-col-4 md:l-col-5 lg:l-col-9",
    yextInfo: yextInfo,
    headlineFieldId: "c_websiteBannerExpandedFirstColumnHeadline",
    textFieldId: "c_websiteBannerExpandedFirstColumnText"
  }));
}
export default LayoutTwoColImgText;